<template>
  <div>
    <div class="main">
      <div class="container">
        <div class="search">
          <div>
            <!-- <el-button size="mini" type="primary" @click="openAddSku">新增</el-button> -->
          </div>
          <div>
            <div class="demo-input-suffix">
              发货状态:
              <el-select
                class="searchInput searchInput2 searchInput3"
                size="mini"
                v-model="flow"
                placeholder="请选择"
                @change="sendChange"
              >
                <el-option
                  v-for="item in isSends"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <!--  <div class="demo-input-suffix">
              状态:
              <el-select
                class="searchInput searchInput2 searchInput3"
                v-model="statusSingle"
                placeholder="请选择"
                size="mini"
                @change="statusChange(statusSingle)"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>-->
            <el-input
              class="searchInput"
              size="mini"
              v-model="like"
              placeholder="请输入内容"
              @change="clickEnter"
            ></el-input>
            <el-button size="mini" type="primary" @click="querySku">查询</el-button>
          </div>
        </div>

        <el-table
          :data="skuList.data"
          border
          class="table"
          ref="multipleTable"
          :height="tableHeight"
          @row-click="SkuEdit"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="SKU" prop="sku">
            <template slot-scope="scope">
              <span @click.stop>{{scope.row.sku}}</span>
            </template>
          </el-table-column>
          <el-table-column label="英文名" prop="skuEnName">
            <template slot-scope="scope">
              <span @click.stop>{{scope.row.skuEnName}}</span>
            </template>
          </el-table-column>
          </el-table-column>
          <el-table-column label="物流名称" prop="skuCnName">
            <template slot-scope="scope">
              <span @click.stop>{{scope.row.skuCnName}}</span>
            </template>
          </el-table-column>
          </el-table-column>
          <el-table-column label="总入库数" prop="totalHaveInStore" v-if="stockShow"></el-table-column>
          <el-table-column label="库存数量" prop="curHaveInStore"></el-table-column>
          <el-table-column label="销售数量" prop="saleCount"></el-table-column>
          <el-table-column label="操作" prop width="300">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.sendStatus==0"
                style="margin-right:5px;"
                @click.stop="goDeliverGoods(scope.row.sku)"
              >去发货</el-button>
              <a
                :href="scope.row.purchaseUrl"
                style="margin-right:5px"
                target="_blank"
                v-if="scope.row.purchaseUrl"
                @click.stop
              >
                <el-button
                  type="primary"
                  size="mini"
                >采购链接</el-button>
              </a>
              <a :href="scope.row.landingUrl" v-if="scope.row.landingUrl" target="_blank" @click.stop>
                <el-button type="primary" size="mini">落地页</el-button>
              </a>
            </template>
          </el-table-column>
        </el-table>

        <!-- <div class="item" v-for="(item,index) in skuList.data" @click="SkuEdit(item)" :key="index">
          <span @click.stop>
            <el-checkbox v-model="item.isFlag" @change="(e)=>singleChecked(e,item.id)"></el-checkbox>
          </span>
          <span>{{ index+1 }}</span>
          <span @click.stop>{{ item.sku }}</span>
          <span>{{ item.skuEnName }}</span>
          <span>{{ item.skuCnName }}</span>
          <span v-if="stockShow">{{item.totalHaveInStore}}</span>
          <span>{{item.curHaveInStore}}</span>
          <span>{{ item.saleCount }}</span>
          <span>{{item.createTime}}</span>
          <span @click.stop style="width:300px">
            <!-- <el-button type="text" @click.stop="removeItem(item.id)">删除</el-button> 
          </span>
        </div>-->
        <!-- 新增SKU -->
        <el-dialog
          title="新增SKU"
          :visible.sync="dialogFormVisible"
          width="650px"
          :close-on-click-modal="false"
        >
          <div class="content">
            <el-form ref="form" :model="form" label-width="120px" size="small">
              <el-form-item label="SKU:">
                <el-input class="oinput" size="small" v-model="sku" placeholder="SKU"></el-input>
              </el-form-item>
              <el-form-item label="英文名:">
                <el-input class="oinput" size="small" v-model="skueng" placeholder="SKU英文名"></el-input>
              </el-form-item>
              <el-form-item label="物流名称:">
                <el-input class="oinput" size="small" v-model="skuchsnote" placeholder="物流名称"></el-input>
              </el-form-item>
              <el-form-item label="采购链接:">
                <el-input class="oinput" size="small" v-model="purchaseurl" placeholder="采购链接"></el-input>
              </el-form-item>
              <el-form-item label="库存数量:">
                <el-input-number v-model="stock" size="small" :min="1" label="描述文字"></el-input-number>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="addsku">确 定</el-button>
            <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 修改SKU -->
        <el-dialog
          title="修改SKU"
          :visible.sync="dialogFormVisible2"
          width="650px"
          :close-on-click-modal="false"
        >
          <div class="content">
            <el-form ref="form" :model="form" label-width="100px" size="small">
              <el-form-item label="英文名:">
                <el-input
                  class="oinput"
                  size="small"
                  v-model="query.skuEnName"
                  placeholder="SKU英文名"
                ></el-input>
              </el-form-item>
              <el-form-item label="物流名称:">
                <el-input class="oinput" size="small" v-model="query.skuCnName" placeholder="物流名称"></el-input>
              </el-form-item>
              <el-form-item label="采购链接:">
                <el-input
                  class="oinput"
                  size="small"
                  v-model="query.purchaseUrl"
                  placeholder="采购链接"
                ></el-input>
              </el-form-item>
              <el-form-item label="落地页:">
                <el-input
                  class="oinput"
                  size="small"
                  v-model="query.landingUrl"
                  placeholder="落地页链接"
                ></el-input>
              </el-form-item>
              <el-form-item label="总入库数量:" v-if="stockShow">
                <el-input-number
                  v-model="query.totalHaveInStore"
                  size="small"
                  :min="1"
                  label="请填写入库数量"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="重量:">
                <el-input v-model="query.weight" size="small" label="描述文字"></el-input>
              </el-form-item>
              <el-form-item label="成本价:">
                <el-input v-model="query.cost" size="small" label="描述文字"></el-input>
              </el-form-item>
              <el-form-item label="货物类型:">
                <el-input v-model="query.cargoRemarks" type="textarea" size="small" label="描述文字"></el-input>
              </el-form-item>
              <el-form-item label="备注:">
                <el-input v-model="query.remarks" type="textarea" size="small" label="描述文字"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="editSku()">确 定</el-button>
            <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
        <div class="pag">
          <el-pagination
            background
            :page-sizes="[20, 50, 100, 200]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="skuList.totalData"
            @current-change="pageChange"
            @size-change="sizeChange"
          ></el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import { addSku, getSkuData, operationSku, getskuDetail } from "../../service";
import { GetSkuList, UpdateSkuInfo, GetSkuIsTotalStockShow } from "@/utils/api";
export default {
  data() {
    return {
      query: {},
      dialogFormVisible: false,
      dialogFormVisible2: false,
      form: {
        name: ""
      },
      input: "",
      tableHeight:"",
      allChecked: false,
      elswitch: "0",
      sku: "",
      skueng: "", //英文名
      skuchsnote: "", //物流名称
      purchaseurl: "", //采购链接
      landingUrl: "", //落地页
      stock: 1, //库存数量
      like: "", //模糊查询
      skuList: {},
      skuid: null, //sku的id
      pageStart: 1, //分页的当前页数
      size: 20, //每页显示条数，默认显示20条每页
      isSends: [
        {
          //发货状态
          id: 1,
          name: "全部"
        },
        {
          id: 0,
          name: "未发货"
        }
      ],
      flow: 1, //发货状态选中
      statusList: [
        //状态筛选项列表
        {
          value: 2,
          label: "全部"
        },
        {
          value: 1,
          label: "已启用"
        },
        {
          value: 0,
          label: "已禁用"
        }
      ],
      statusSingle: "", //状态
      stockShow: true
    };
  },
  created() {
    this.getSku();
  },
  mounted(){
    this.$nextTick(()=>{
      this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop -160;
    })
  },
  methods: {
    //获取sku列表数据
    getSku(pageStart = 1) {
      let params = {
        pageStart,
        searchText: this.like,
        limit: this.size,
        flowStatus: this.flow
      };
      GetSkuIsTotalStockShow().then(res => {
        this.stockShow = res;
      });
      GetSkuList(params).then(res => {
        if (res) {
          this.skuList = res;
          this.skuList.data.map((item, i) => {
            item.isFlag = false;
          });
        }
      });
    },
    // 查询sku
    querySku() {
      this.getSku(1);
    },
    //确定新增sku
    addsku() {
      this.dialogFormVisible = false;
      let params = {
        sku: this.sku,
        skueng: this.skueng,
        skuchsnote: this.skuchsnote,
        purchaseurl: this.purchaseurl,
        stock: this.stock
      };
      addSku(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: "新增sku成功",
            type: "success",
            duration: 1000,
            onClose: () => {
              this.getSku();
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 确定修改sku
    editSku() {
      this.dialogFormVisible2 = false;
      if (this.query.weight) {
        this.query.weight = Number(this.query.weight);
      }
      if (this.query.cost) {
        this.query.cost = Number(this.query.cost);
      }
      UpdateSkuInfo(this.query).then(res => {
        if (res) {
          this.$message({
            message: "修改sku成功",
            type: "success",
            duration: 1000,
            onClose: () => {
              this.getSku(this.pageNum);
            }
          });
        }
      });
    },
    // 去发货
    goDeliverGoods(sku) {
      this.$router.push({
        path: "/shopifyOrder",
        query: {
          sku
        }
      });
    },
    //发货状态选中发生改变
    sendChange(val) {
      this.getSku();
    },
    // 状态选中发生改变
    statusChange(val) {
      this.getSku();
    },
    // 分页
    pageChange(p) {
      this.allChecked = false;
      this.pageStart = p;
      this.getSku(p);
    },
    // 分页的每页条数发生改变
    sizeChange(val) {
      this.size = val;
      this.getSku();
    },
    //打开修改sku
    SkuEdit(item) {
      this.query = JSON.parse(JSON.stringify(item));
      this.dialogFormVisible2 = true;

      // this.skuid = id;
      // let params = { id };
      // getskuDetail(params).then(res => {
      //   this.dialogFormVisible2 = true;
      //   if (res.data.code === 0) {
      //     this.skueng = res.data.result.skueng;
      //     this.skuchsnote = res.data.result.skuchsnote;
      //     this.purchaseurl = res.data.result.purchaseurl;
      //     this.stock = res.data.result.stock;
      //   } else {
      //     this.$message.error(res.data.msg);
      //   }
      // });
    },
    // 打开新增sku
    openAddSku() {
      this.dialogFormVisible = true;
      this.sku = "";
      this.skueng = "";
      this.skuchsnote = "";
      (this.purchaseurl = ""), (this.stock = "");
    },
    // 删除sku
    removeItem(id) {
      this.$confirm("确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      })
        .then(() => {
          let params = { id, opt: 2 };
          operationSku(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: "删除成功!",
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.getSku(this.pageNum);
                }
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // sku状态发生改变
    switchChange(val, id) {
      let params = { id: id, opt: val };
      operationSku(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: "sku状态修改成功",
            type: "success"
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 点击改变单选
    singleChecked(e, id) {
      let arr = JSON.parse(JSON.stringify(this.skuList.page));
      arr.map((item, i) => {
        if (item.orderno === id) {
          this.$set(item, "isFlag", e);
        }
      });
      this.skuList.data = JSON.parse(JSON.stringify(arr));
      this.isAllChecked();
    },
    // 单选改变全选
    isAllChecked() {
      let flag = true;
      this.skuList.data.map((item, i) => {
        if (item.isFlag === false) {
          flag = false;
        }
      });
      this.allChecked = flag;
    },
    // 全选改变单选
    allChenkedChange(e) {
      let arr = JSON.parse(JSON.stringify(this.skuList.data));
      arr.map((item, i) => {
        arr[i].isFlag = e;
      });
      this.skuList.data = JSON.parse(JSON.stringify(arr));
    },
    // 点击回车触发查询
    clickEnter() {
      this.getSku();
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  background-color: #fff;
  border: 1px solid rgba(235, 237, 248, 1);
}
.table{
  height:calc(100vh - 190px);
}
.container {
  width: 100%;
  padding: 0 20px;
  padding-top: 20px;
  border: none;
  box-sizing: border-box;
  .search {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    > div {
      display: flex;
      justify-content: flex-end;
      > div {
        margin-right: 6px;
      }
    }
    > div:last-child {
      margin-right: 0px;
    }
    .searchInput {
      width: 200px;
      border-radius: 4px;
      /deep/ .el-input__inner {
        border-radius: 4px;
      }
    }
    .searchBtn {
      height: 40px;
      background: rgba(0, 119, 255, 1);
      border-radius: 0px 3px 3px 0px;
    }
  }
  .total {
    margin: 10px 0;
  }
  .itemNav,
  .item {
    padding-left: 18px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 30px;
      display: inline-block;
      margin-right: 0;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 4%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 12%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 14%;
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 8%;
    }
    span:nth-child(7) {
      display: inline-block;
      text-align: center;
      width: 8%;
    }
    span:nth-child(8) {
      display: inline-block;
      text-align: center;
      width: 12%;
    }
    span:nth-child(9) {
      display: inline-block;
      text-align: center;
      width: 14%;
    }
    span:nth-child(10) {
      display: inline-block;
      text-align: center;
      width: 15%;
      span {
        display: inline;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
      span:nth-child(2),
      span:nth-child(4) {
        margin: 0 3px;
        color: #e6e6e6;
      }
      a {
        color: #1890ff;
      }
    }
  }
  .itemNav {
    margin-bottom: 10px;
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 48px;
    &:hover {
      background-color: #eee;
      cursor: pointer;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(10) {
      color: #1980ff;
      > span {
        display: inline;
        color: #1980ff;
        &:hover {
          cursor: pointer;
        }
      }
      > span:nth-child(2) {
        margin: 0 4px;
        color: #e6e6e6;
        &:hover {
          cursor: auto;
        }
      }
      /deep/ .el-dropdown {
        width: 30px;
        span {
          color: #1980ff;
        }
      }
      > .more {
        display: inline;
      }
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}

.dialog-footer {
  text-align: center;
}
.el-form-item {
  margin-bottom: 6px;
}
.searchInput3 {
  width: 100px !important;
}
/deep/ .el-table__row {
  cursor: pointer;
}
</style>